import React from 'react';

const VehicleRow = ({ vehicle }) => {
  return (
    <div className="vehicle-row">
      <div className="row-image">
        <img
          src={vehicle.images[0]}
          alt={vehicle.title}
          onError={(e) => (e.target.src = "/img/datlogoA.png")}
        />
      </div>
      <div className="row-content">
        <h3>{vehicle.title}</h3>
        <p className="row-description">{vehicle.description}</p>
        {vehicle.images.length > 1 && (
          <div className="row-gallery">
            {vehicle.images.slice(1).map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`${vehicle.title} ${index + 1}`}
                onError={(e) => (e.target.src = "/img/datlogoA.png")}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VehicleRow;